function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Inner } from '@finect/tabular-core/Inner';
import { getProductTypeById } from '@finect/front-resources/Products';
import { keyMap } from '@finect/front-utils/keyMap';
import { menu } from '../data';
import { TopicContents } from './TopicContents';
import { PortalSection } from './PortalSection';
const slideDown = keyframes(["from{max-height:0;}to{max-height:500px;}"]);
export const TopicBlock = styled.div.withConfig({
  displayName: "PortalNew__TopicBlock",
  componentId: "sc-1jdehuy-0"
})(["display:", ";position:fixed;top:", "px;left:0;right:0;overflow:hidden;padding-top:0;box-shadow:0 4px 24px rgba(46,46,51,0.25);animation:", " 0.5s ease;"], _ref => {
  let {
    show
  } = _ref;
  return show ? 'block' : 'none';
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.navHeight;
}, slideDown);
export const TopicBlockInner = styled.div.withConfig({
  displayName: "PortalNew__TopicBlockInner",
  componentId: "sc-1jdehuy-1"
})(["background-color:#fff;"]);
export class Portal extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "ref", React.createRef());
    _defineProperty(this, "handleOutsideClick", event => {
      if (this.ref && this.ref.current && !this.ref.current.contains(event.target)) {
        if (this.props.show) {
          this.props.closeTopic();
        }
      }
    });
    _defineProperty(this, "handleKeydown", event => {
      if (event.keyCode === keyMap.ESCAPE) {
        if (this.props.show) {
          this.props.closeTopic();
        }
      }
    });
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      document.addEventListener('click', this.handleOutsideClick);
      document.addEventListener('keydown', this.handleKeydown, false);
    }
    if (!this.props.show && prevProps.show) {
      document.removeEventListener('click', this.handleOutsideClick);
      document.removeEventListener('keydown', this.handleKeydown, false);
    }
  }
  render() {
    const {
      show,
      finectApp,
      closeTopic,
      productFamilies = [],
      links,
      banks = [],
      storefronts = []
    } = this.props;
    const sections = menu[0].children.map(_ref3 => {
      let {
        entitiesType,
        entitiesFilter,
        title,
        link = null
      } = _ref3;
      if (entitiesType === 'productFamily') {
        const items = productFamilies.map(family => _objectSpread(_objectSpread({}, {
          productType: getProductTypeById(family.type)
        }), family)).filter(_ref4 => {
          let {
            productType
          } = _ref4;
          return Boolean(productType);
        });
        const indexFundsItem = {
          productType: {
            slug: 'fondos-indexados',
            plural: 'Fondos indexados',
            tag: 'fondos-indexados',
            views: []
          },
          id: 1,
          alias: 'fondos-indexados',
          familly: 'index-funds',
          type: 'index-fund'
        };
        items.length > 1 ? items.splice(1, 0, indexFundsItem) : items.push(indexFundsItem);
        return {
          title,
          link,
          entitiesType,
          items
        };
      }
      if (entitiesType === 'link') {
        return {
          title,
          link,
          entitiesType,
          items: links
        };
      }
      if (entitiesType === 'storefront') {
        return {
          title,
          link,
          entitiesType,
          items: storefronts.filter(_ref5 => {
            let {
              types
            } = _ref5;
            return types.find(_ref6 => {
              let {
                type
              } = _ref6;
              return type === entitiesFilter;
            });
          })
        };
      }
      if (entitiesType === 'banks') {
        return {
          title,
          link,
          entitiesType,
          items: banks
        };
      }
      return null;
    });
    const handleLinkClick = () => {
      closeTopic();
    };
    return React.createElement(TopicBlock, {
      show: show,
      ref: this.ref
    }, React.createElement(TopicBlockInner, null, React.createElement(Inner, null, React.createElement(TopicContents, null, sections.filter(item => item).map((section, i) => React.createElement(PortalSection, {
      key: i,
      i: i,
      lastItem: i === sections.length - 1,
      onLinkClick: handleLinkClick,
      finectApp: finectApp,
      title: section && section.title,
      link: section && section.link,
      entities: {
        items: section && section.items,
        type: section && section.entitiesType
      }
    }))))));
  }
}